import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { Edit } from '@mui/icons-material';


type EditableProps = {
    defaultValue: string | number,
    label?: string,
    placeholder?: string,
    required?: boolean,
    onChange: (v: string | number) => void,
    format?: (v: string | number) => string,
    inputMode?: HTMLAttributes<HTMLInputElement | HTMLTextAreaElement>["inputMode"]
}

const EditableInput = ({defaultValue, onChange, inputMode, format}: EditableProps) => {
    const [editing, setEditing] = useState(false);
    const [state, setState] = useState(defaultValue);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, [editing]);

    const save = () => {
        onChange(state);
        setEditing(false);
    };

    const cancel = () => {
        setState(defaultValue);
        setEditing(false);
    };

    const keyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        switch (e.key) {
            case 'Enter':
                save();
                break;
            case 'Esc': // IE/Edge specific value
            case 'Escape':
                cancel();
                break;
            default:
                return;
        }
    };

    if (!editing) {
        if (!state) {
            return (
                <IconButton
                    size="small"
                    onClick={() => setEditing(true)}
                >
                    <Edit fontSize="small"/>
                </IconButton>
            )
        }

        return (
            <Box
                onClick={() => setEditing(true)}
                sx={{
                    border: '1px solid transparent',
                    borderRadius: '4px',
                    "&:hover": {
                        borderColor: 'rgba(0, 0, 0, 0.87)',
                    },
                }}
            >
                {format ? format(state) : state}
            </Box>
        );
    }

    return (
        <TextField
            margin="none"
            variant="outlined"
            fullWidth
            inputProps={{
                inputMode: inputMode,
                onKeyDown: keyDown,
            }}
            inputRef={inputRef}
            value={state || ''}
            onChange={e => setState(e.target.value)}
        />
    );
};

export default EditableInput;